import type { IUser } from '@featit/shared';

/**
 * Whether an answer says mail to this person is stopped: a known reason and the address it is about.
 * Anything else (no answer, a reason of null, a shape this build does not know, an empty address)
 * reads as "not stopped", so a malformed or unexpected answer never tells a person their mail is
 * blocked (gate 535: a generic answer drew "Mail to  bounced." over every phone screen).
 */
export function isStoppedStanding(standing: NonNullable<IUser['mailStanding']> | null): boolean {
  return Boolean(
    standing &&
    (standing.reason === 'bounced' || standing.reason === 'complained') &&
    typeof standing.address === 'string' &&
    standing.address.trim() !== '',
  );
}
